import { render, staticRenderFns } from "./versionToExamine.vue?vue&type=template&id=6cfe133d&scoped=true&"
import script from "./versionToExamine.vue?vue&type=script&lang=js&"
export * from "./versionToExamine.vue?vue&type=script&lang=js&"
import style0 from "./versionToExamine.vue?vue&type=style&index=0&id=6cfe133d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe133d",
  null
  
)

export default component.exports